export default "__VITE_ASSET__G1FlfUJy__"